var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-cell"},[_c('DxSparkline',{attrs:{"data-source":_vm.cellData,"show-min-max":true,"point-size":6,"argument-field":"date","value-field":"close","type":"line","min-color":"#f00","max-color":"#2ab71b"}},[_c('DxSize',{attrs:{"width":290,"height":40}}),_c('DxTooltip',{attrs:{"enabled":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }